/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupUserDetailsModule } from '../user-details';
import { BuilderSetupManagerRoutingModule } from './builder-setup-manager-routing.module';
import { ManagerTabContainerComponent } from './components/manager-tab-container/manager-tab-container.component';
import { OfficeRoleListTabComponent } from './components/office-role-list-tab/office-role-list-tab.component';
import { OfficeRolePermissionsGeneralTabComponent } from './components/office-role-permissions-application-tab/office-role-permissions-general-tab.component';
import { OfficeRolePermissionsSetupTabComponent } from './components/office-role-permissions-application-tab/office-role-permissions-setup-tab.component';
import { OfficeRoleTodoPermissionTabComponent } from './components/office-role-permissions-application-tab/office-role-todo-permission-tab/office-role-todo-permission-tab.component';
import { OfficeRolePermissionsTabContainerComponent } from './components/office-role-permissions-tab-container/office-role-permissions-tab-container.component';
import { OfficeRoleListBusinessService } from './resources/office-role-list-business.service';
import { OfficeRolePermissionsBusinessService } from './resources/office-role-permissions-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupManagerRoutingModule,

    BuilderSetupUserDetailsModule,
  ],
  providers: [
    OfficeRolePermissionsBusinessService,
    OfficeRoleListBusinessService,
  ],
  declarations: [
    ManagerTabContainerComponent,
    OfficeRoleListTabComponent,
    OfficeRolePermissionsTabContainerComponent,
    OfficeRolePermissionsGeneralTabComponent,
    OfficeRolePermissionsSetupTabComponent,
    OfficeRoleTodoPermissionTabComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})
export class BuilderSetupManagerModule {
}
